import { Excel } from "antd-table-saveas-excel";
import constants from "../constants/constants";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { message } from "antd";
import WebLinks from "../api/WebLinks";
import APIUtils from "../api/APIUtils";

	//Download table into an excel file
	export const DownloadExcel = (columns,data,filename,sheetName) => {
    const excel = new Excel();
    excel
      .addSheet(sheetName)
      .addColumns(columns)
      .addDataSource(data, {
        str2Percent: true
      })
      .saveAs(filename+".xlsx");
  };

  //Get todays date
  export const GetTodaysDateString =()=>{
    let todaysDate=dayjs().format(constants.DateFormat);
    return todaysDate;
  };

  //Table search functionality logic
  export const GetSearchFilteredData=(value,dataSet)=>{
    let searchData=dataSet.filter(item =>Object.keys(item)
		.some(k =>String(item[k]).toLowerCase().includes(value.toLowerCase()))
		)
    return searchData;
  };

  //Get priority level icons
  export const GetPriorityLevelIcons=(priorityLevel)=>{
    switch (priorityLevel) {
      case 10: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-white"></div>);
      case 1: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-lime-400"></div>);
      case 2: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-orange-400"></div>);
      case 3: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-red-600"></div>);
      case 4: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-purple-600"></div>);
      default: return(<div className="w-3.5 h-3.5 border rounded-full border-black bg-white"></div>);
    }
  }

  //Get custom priority level icons
  export const GetCustomPriorityLevelIcons=(priorityLevel)=>{
    switch (priorityLevel) {
      case 1: return"w-3.5 h-3.5 border rounded-full border-black bg-lime-400";
      case 2: return"w-3.5 h-3.5 border rounded-full border-black bg-green-900";
      case 3: return"w-3.5 h-3.5 border rounded-full border-black bg-yellow-400";
      case 0: return"w-3.5 h-3.5 border rounded-full border-black bg-white";
      case 4: return"w-3.5 h-3.5 border rounded-full border-black bg-orange-400";
      case 5: return"w-3.5 h-3.5 border rounded-full border-black bg-red-600";
      case 6: return"w-3.5 h-3.5 border rounded-full border-black bg-pink-600";
      case 7: return"w-3.5 h-3.5 border rounded-full border-black bg-purple-600";
      case 8: return"w-3.5 h-3.5 border rounded-full border-black bg-slate-900";
      default: return"w-3.5 h-3.5 border rounded-full border-black bg-white";
    }
  }

  //Get priority level colors
  export const GetPriorityLevelColors=(priorityLevel)=>{
    switch (priorityLevel) {
      case 10: return "w-3.5 h-3.5 border rounded-full border-black bg-white";
      case 1: return "w-3.5 h-3.5 border rounded-full border-black bg-lime-400";
      case 2: return "w-3.5 h-3.5 border rounded-full border-black bg-orange-400";
      case 3: return "w-3.5 h-3.5 border rounded-full border-black bg-red-600";
      case 4: return "w-3.5 h-3.5 border rounded-full border-black bg-purple-600";
      default: return "w-3.5 h-3.5 border rounded-full border-black bg-white";
    }
  }

  //Get priority level colors
  export const GetMonthText=(value)=>{
    switch (value) {
      case 1: return "Jan";
      case 2: return "Feb";
      case 3: return "Mar";
      case 4: return "Apr";
      case 5: return "May";
      case 6: return "Jun";
      case 7: return "Jul";
      case 8: return "Aug";
      case 9: return "Sep";
      case 10: return "Oct";
      case 11: return "Nov";
      case 12: return "Dec";
      default: return "Jan";
    }
  }
  //Function to get priority count
  export const getPriorityCount=(priorityValue,priorityCountListValues)=>{
    let filterPriority= priorityCountListValues?.filter((item)=>item.priorityLevel===priorityValue);
    if (filterPriority.length>0){
      return filterPriority[0].priorityCount;
    }else{
      return 0;
    }
  }

  //Function to download file
  export const downloadFiles = (urlValue,filename,body=null) => {
    const url = urlValue
    const accessToken = Cookies.get(constants.COOKIE_TOKEN)
    return fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: body
    })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            message.success('File downloaded successfully');
            return blob;
        })
        .catch(error => {
            message.error('Error downloading file');
            throw error;
        });
}

//Function to get currency name
export const getCurrencyName= (symbol)=>{ 
  switch (symbol) {
    case "$":
      return 'USD';
    case "£":
      return 'GBP';
    case "€":
      return 'EUR';
    default:
      return "";
  }
}


//Function to replace names
export const getBuyerNameById = (id,name) => {
  const intId = parseInt(id);
  const loggedInId=parseInt(Cookies.get(constants.COOKIE_LOGGED_BUYER_ID));
  const userIds = [1342,
    1341,
    1265,
    1223,
    892,
    886,
    828,
    592];

  if (userIds.includes(loggedInId)) {
    switch (intId) {
      case 411:
        return 'Demo UK Health Advanced';
      case 1045:
        return 'Demo UK Health';
      case 1228:
        return 'Demo UK Hospitality';
      case 607:
        return 'Demo UK Hotel';
      default:
        return name;
    }
    }else{
      return name;
    }
};
export const convertFirstCharToUpperCase = (inputValue) => {
    if (!inputValue) return "";
    return inputValue.charAt(0)?.toUpperCase() + inputValue?.slice(1);
  }

//Function to return Supplier type
export const getSupplierTypes=(organic , boost , postingCredits , cpa , alwaysOn )=> {
  const result = [];

  if (organic) result.push("Organic");
  if (boost) result.push("Boost");
  if (postingCredits) result.push("Posting Credits");
  if (cpa) result.push("CPA");
  if (alwaysOn) result.push("Always On");

  return result.join(", ");
}

//Function to track page access
export const trackPageAccess=async(buyerId,pagerURL)=>{
    const normalizedUrl = (pagerURL || '').toLowerCase();
    const shouldCreatePayload = !normalizedUrl.includes('localhost') && !normalizedUrl.includes('new.hireintelligence');

    if (shouldCreatePayload) {
    let payload=null;
    payload={
      buyerId:buyerId||Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      createdByBuyerId:Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      pageURL:pagerURL
    }
		const Response = await APIUtils.apiCall("POST",WebLinks.LogPageAccess,JSON.stringify(payload));
  }
}

export const fetchFiles = async (urlValue, body = null) => {
  try {
    const response = await fetch(urlValue, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${Cookies.get(constants.COOKIE_TOKEN) } `,
      },
      body,
    });
    if (!response.ok) {
      throw new Error(`Request failed with status ${ response.status } `);
    }
    const blob = await response.blob();
    return blob;
  } catch (error) {
    message.error('Error generating file');
    throw error;
  }
};
